import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-datamars',
    templateUrl: './datamars.component.html',
    styleUrls: ['./datamars.component.scss'],
    standalone: false
})
export class DatamarsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
